// Create a dummy Image so that the image will be cached
export default url => {
	if (!window.Image) { return; }

	const i = new Image();
	i.src = url;
};
